// Sep 2026 — RM Inward (With Invoice) list-query helpers.
//
// `buildBillParams` maps the screen's filter state to the query params
// `GET /rm-inward/bills` accepts (server-side status / branch /
// bill_number search / inclusive bill_date range). Both the paged list
// fetch and the export share it so they can never drift apart.
//
// `fetchAllRmInwardBills` powers the Export button: it pages through
// the endpoint at page_size=200 until every matching bill has been
// pulled — the export must reflect the complete filtered set, never
// the already-loaded page slice.
//
// NOTE: ESM exports — the production webpack build rejects named ESM
// imports from CommonJS modules. Jest coverage runs via `craco test`
// (babel transforms this file), NOT plain `npx jest`.

import axios from "axios";

const EXPORT_PAGE_SIZE = 200;

const buildBillParams = ({ status, branch, search, from, to } = {}) => {
  const params = {};
  if (branch && branch !== "ALL") params.branch = branch;
  if (status && status !== "ALL") params.status = status;
  if (search && search.trim()) params.search = search.trim();
  if (from) params.date_from = from;
  if (to) params.date_to = to;
  return params;
};

const fetchAllRmInwardBills = async (api, token, baseParams = {}) => {
  let page = 1;
  let totalPages = 1;
  let all = [];
  do {
    const { data } = await axios.get(`${api}/rm-inward/bills`, {
      params: { ...baseParams, page, page_size: EXPORT_PAGE_SIZE },
      headers: { Authorization: `Bearer ${token}` },
    });
    all = all.concat(data.bills || []);
    totalPages = data.total_pages || 1;
    page += 1;
  } while (page <= totalPages);
  return all;
};

export { buildBillParams, fetchAllRmInwardBills, EXPORT_PAGE_SIZE };
